import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { UserAdminSetPasswordValidityPayload } from 'api/actions/user-admin-set-password-validity/user-admin-set-password-validity-payload';
import { UserAdminSetPasswordValidityPathParameters } from 'api/actions/user-admin-set-password-validity/user-admin-set-password-validity-path-parameters';
import { UserAdminSetPasswordValidityResponse } from 'api/actions/user-admin-set-password-validity/user-admin-set-password-validity-response';

type UserAdminSetPasswordValidityQueryParameters = Record<string, any>;

/**
 * The path of the UserAdminSetPasswordValidity action.
 */
export const userAdminSetPasswordValidityActionPath = new SweetPath<keyof UserAdminSetPasswordValidityPathParameters>(
  '/api/user/admin-set-password-validity/{userId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized UserAdminSetPasswordValidity actions.
 */
export default function createUserAdminSetPasswordValidityAction(axios: AxiosInstance) {
  return function userAdminSetPasswordValidityAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: UserAdminSetPasswordValidityPathParameters;
    query?: UserAdminSetPasswordValidityQueryParameters;
    payload: UserAdminSetPasswordValidityPayload;
  }) {
    const path = userAdminSetPasswordValidityActionPath.insert(parameters);

    return axios.request<UserAdminSetPasswordValidityResponse, UserAdminSetPasswordValidityResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
